<script lang="ts">
    
    import { onMount } from "svelte";
    import { useNavigate } from "svelte-navigator";

    export let to: string;

    const navigate = useNavigate();

    onMount(() => navigate(to));

</script>

Redireccionando...
